import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../../colors';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    backgroundColor: 'white',
  },
  welcomeBox: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral100}`,
    background: colors.white,
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    alignSelf: 'stretch',
  },
  welcomeFrame: {
    display: 'flex',
    padding: '32px',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '32px',
    alignSelf: 'stretch',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  sectionTitle: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px',
    letterSpacing: '-0.22px',
    margin: 0,
  },
  sectionSubtitle: {
    color: colors.neutral500,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    margin: 0,
  },
  askBox: {
    display: 'flex',
    padding: '24px',
    paddingBottom: '0px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
  },
  contentHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px'
  },
  sayBox: {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    background: colors.primary50,
  },
  askContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '40px',
    alignItems: 'flex-start',
    gap: '12px',
    alignSelf: 'stretch'
  },
  firstLineLayout: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch'
  },
  firstLine: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    flex: 1,
    margin: 0,
  },
  askIcon: {
    color: colors.secondary500,
    height: '24px',
    width: '24px',
    '& path': {
      fill: colors.secondary500,
    },
  },
  sayIcon: {
    color: colors.success500,
    height: '24px',
    width: '24px',
    '& path': {
      stroke: colors.success500,
    },
  },
  instruction: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
    padding: '12px',
    borderRadius: '2px 12px 12px 12px',
  },
  animatedIcon: {
    width: '80px',
    height: '80px',
  },
});
